<template>
  <Modal
    v-model="_value"
    width="500"
    title='短信HIK:触发报警行为'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">

    <Form :label-width="110">
      <FormItem prop="alarm" label="触发报警行为">
        <Select v-model="alarm" style="width: 220px;" @on-change="onChange">
          <Option v-for="item in alarmOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="sms" label="短信内容">
        <Input v-model="sms" readonly placeholder="短信内容" style="width: 300px;">
        </Input>
      </FormItem>
    </Form>

  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setuphiktriggeralarmsmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        simNum:null,

        //报警行为选项
        alarm:null,
        alarmOptions: [
          {name: '右侧盲区报警', value: 23},
          {name: '生理疲劳(批量驾驶)', value: 60},
          {name: '接打电话报警', value: 61},
          {name: '抽烟报警', value: 62},
          {name: '分心驾驶', value: 63},
          {name: '未系安全带', value: 66},
          {name: '双手脱离方向盘', value: 73},
          {name: '单手脱离方向盘', value: 74},
          {name: '玩手机', value: 75},
          {name: '前车碰撞', value: 80},
        ],

        sms:null,
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onChange(){
        this.sms = 'SmartTrig:'+this.alarm+';A'
      },
      onOk() {
        if (!this.alarm || this.alarm === '') {
          this.$Message.error('请选择报警行为')
          return
        }
          this.sendSMS('SmartTrig:'+this.alarm+';A')

      },
      sendSMS (content) {
        if (!this.simNum || this.simNum === '') {
          this.$Message.error('请选择SIM卡号')
          return
        }
        store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
